import { z } from "zod";

export const businessFormSchema = z.object({
  businessName: z.string().min(2, {
    message: "Business name must be at least 2 characters.",
  }),
  description: z.string().min(10, {
    message: "Business description must be at least 10 characters.",
  }),
  phone: z.string().min(10, {
    message: "Please enter a valid phone number.",
  }),
  suite: z.string().optional(),
  street: z.string().min(4, {
    message: "street must be at least 4 characters.",
  }),
  city: z.string().min(2, {
    message: "City must be at least 2 characters.",
  }),
  state: z.string().min(2, {
    message: "State must be at least 2 characters.",
  }),
  zipCode: z.string().min(4, {
    message: "ZIP code must be at least 5 characters.",
  }),
  country: z.string().min(1, {
    message: "Country is required.",
  }),
});

export type BusinessFormValues = z.infer<typeof businessFormSchema>;
